import React from 'react'
import WorkSummaryListViewItem from './WorkSummaryListViewItem'

export default ({
  workSummaries,
  onWorkSummaryClick,
  searchText,
  onSearchTextChange,
}) => {
  return (
    <div className="h-full flex flex-col">
      <div className="w-full px-3 py-2">
        <div className="relative">
          <input
            type="text"
            value={searchText}
            onChange={onSearchTextChange}
            placeholder="Search staff..."
            className="w-full px-4 py-3 pr-10 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#aa6326] focus:border-transparent transition-all"
          />
          <svg
            className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-3">
        <div className="space-y-2">
          {workSummaries &&
            workSummaries.map((workSummary) => (
              <WorkSummaryListViewItem
                key={workSummary.staff._id}
                workSummary={workSummary}
                onWorkSummaryClick={onWorkSummaryClick}
              />
            ))}
        </div>
      </div>
    </div>
  )
}
